<template>
  <MobilePromoCard
    v-if="visible"
    :logo="logo"
    :title="$t('mobile.installTitle', { name })"
    :subtitle="$t('mobile.installSubtitle')"
    :cta-label="$t('mobile.installButton')"
    :dismiss-label="$t('mobile.installDismiss')"
    @cta="guideOpen = true"
    @dismiss="dismiss"
  >
    <MobileBottomSheet
      v-model="guideOpen"
      :title="$t('mobile.installTitle', { name })"
      :close-label="$t('Close')"
    >
      <MobileInstallGuide
        v-if="guideOpen"
        :name="name"
        :logo="logo"
        :can-prompt="canPrompt"
        @prompt="promptInstall"
      />
    </MobileBottomSheet>
  </MobilePromoCard>
</template>

<script>
import { isInstalledApp } from "@/utils/pushNotifications";
import MobileBottomSheet from "./MobileBottomSheet.vue";
import MobileInstallGuide from "./MobileInstallGuide.vue";
import MobilePromoCard from "./MobilePromoCard.vue";

const DISMISS_KEY = "mInstallBannerDismissedAt";
/** Cerrado, vuelve a aparecer después de esto. */
const DISMISS_DAYS = 14;

function dismissedRecently() {
  try {
    const at = Number(localStorage.getItem(DISMISS_KEY) || 0);
    return at > 0 && Date.now() - at < DISMISS_DAYS * 24 * 60 * 60 * 1000;
  } catch (e) {
    return false;
  }
}

/**
 * Teléfono abierto desde el navegador (no la app instalada): recomienda instalarla. «Instalar»
 * abre la guía (MobileInstallGuide): pregunta Android o iPhone y muestra los pasos con dibujos.
 * En Android, si el navegador ofrece el diálogo nativo (guardado en
 * modules/telegram_ai_module/index.js), la guía lo ofrece primero. Se puede cerrar por unos días.
 */
export default {
  name: "MobileInstallBanner",
  components: { MobileBottomSheet, MobileInstallGuide, MobilePromoCard },
  props: {
    name: { type: String, default: "" },
    logo: { type: String, default: "" },
  },
  data() {
    return { visible: false, guideOpen: false, canPrompt: false };
  },
  mounted() {
    const touch = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
    this.visible = touch && !isInstalledApp() && !dismissedRecently();
    this.canPrompt = !!window.__exportaiInstallPrompt;
    window.addEventListener("appinstalled", this.onInstalled);
  },
  beforeDestroy() {
    window.removeEventListener("appinstalled", this.onInstalled);
  },
  methods: {
    onInstalled() {
      this.visible = false;
      window.__exportaiInstallPrompt = null;
    },
    async promptInstall() {
      const prompt = window.__exportaiInstallPrompt;
      if (!prompt) return;
      prompt.prompt();
      const choice = await prompt.userChoice;
      window.__exportaiInstallPrompt = null;
      this.canPrompt = false;
      if (choice && choice.outcome === "accepted") {
        this.guideOpen = false;
        this.visible = false;
      }
    },
    dismiss() {
      this.visible = false;
      try {
        localStorage.setItem(DISMISS_KEY, String(Date.now()));
      } catch (e) {
        // sin almacenamiento: se cierra solo por esta visita
      }
    },
  },
};
</script>
